<template>
  <aha-modal
    :title="'Change your billing details'"
    @hide="hideModal"
  >
    <div>
      <div class="aha-form">
        <div class="aha-form-group">
          <label class="aha-form-label">{{ $i18nPresenter.t('Billing address') }}</label>
          <aha-textarea
            type="text"
            class="aha-form-control"
            placeholder="Billing address"
            v-model="address"
            :maxLength="500"
          />
        </div>
      </div>
    </div>
    <template #action>
      <aha-button @click="confirmUpdateBillingDetails" :submitting="isUpdatingInfo">
        {{ $i18nPresenter.t('Update') }}
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>
import { mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import util from '@/util'

export default {
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      address: this.currentUser.address,
      isUpdatingInfo: false,
    }
  },

  methods: {
    ...mapActions(['patchCurrentUserAction']),
    hideModal() {
      this.$emit('hide')
    },
    async confirmUpdateBillingDetails() {
      this.isUpdatingInfo = true
      try {
        await this.patchCurrentUserAction({
          userId: this.currentUser.id,
          address: this.address,
        })
        this.$emit('hide')
      } catch (e) {
        Sentry.captureException(e)
        this.isUpdatingInfo = false
        util.showToastError('Cannot update billing details', e.message)
      }
    },
  },
}
</script>
